import {
  faLock,
  faArrowRightFromBracket,
  faKey,
  faBook,
  faWallet,
  faWifi,
  faAddressCard,
  faPlus,
  faArrowLeft,
  faX,
  faCheck,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

export const fontAwesomeIcons = [
  faLock,
  faArrowRightFromBracket,
  faKey,
  faBook,
  faWallet,
  faWifi,
  faAddressCard,
  faPlus,
  faArrowLeft,
  faX,
  faCheck,
  faTrashCan,
];
